import { ApiClient } from "lib/utils/client/apiClient";

export const propertiesWidgetsCount = async () => {
    return ApiClient('/property/admin/properties-counts', {
        method: 'GET',
    });
}

export const propertiesListing = async (data: { status: string, page: number, limit: number, search?: string }) => {
    return ApiClient('/property/admin/properties-listing/status', {
        method: 'POST',
        body: JSON.stringify(data)
    });
}